import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const UpdateScoreContext = createContext(null);

type Props = {
  children: ReactElement;
};

const UpdateScoreProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put(`onboarding/rules`, payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <UpdateScoreContext.Provider value={contextValue}>
      {children}
    </UpdateScoreContext.Provider>
  );
};

export default UpdateScoreProvider;
